module.exports = __webpack_public_path__ + "static/img/hw1.060fb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/hw/hw1.png
// module id = 05sA
// module chunks = 0